const CURRENCIES = [
    {iso: 'USD', sign: '$', name: 'US Dollars'},
    {iso: 'RUB', sign: '\u20bd', name: 'Russian Rouble'},
    {iso: 'GBP', sign: '\u00a3', name: 'British Pound Sterling'},
    {iso: 'INR', sign: '\u20b9', name: 'Indian Rupee'},
    {iso: 'AUD', sign: '$', name: 'Australian Dollar'},
    {iso: 'CAD', sign: '$', name: 'Canadian Dollar'},
    {iso: 'AED', sign: '\u062f.\u0625', name: 'United Arab Emirates Dirham'},
    {iso: 'CHF', sign: 'CHF', name: 'Swiss Franc'},
    {iso: 'JPY', sign: '\u00a5', name: 'Japanese Yen'},
    {iso: 'THB', sign: '\u0e3f', name: 'Thai Baht'},
    {iso: 'AFN', sign: '\u060b', name: 'Afghan Afghani'},
    {iso: 'EUR', sign: '\u20ac', name: 'Euro'},
    {iso: 'DZD', sign: '\u062f\u062c', name: 'Algerian Dinar'},
    {iso: 'AOA', sign: 'Kz', name: 'Angolan Kwanza'},
    {iso: 'ARS', sign: '$', name: 'Argentine Peso'},
    {iso: 'AMD', sign: '\u058f', name: 'Armenian Dram'},
    {iso: 'AWG', sign: '\u0192', name: 'Aruban Florin'},
    {iso: 'AZN', sign: 'm', name: 'Azerbaijani Manat'},
    {iso: 'BSD', sign: '$', name: 'Bahamian Dollar'},
    {iso: 'BHD', sign: '.\u062f.\u0628', name: 'Bahraini Dinar'},
    {iso: 'BDT', sign: '\u09f3', name: 'Bangladeshi Taka'},
    {iso: 'BBD', sign: '$', name: 'Barbados Dollar'},
    {iso: 'BYN', sign: 'Br', name: 'Belarusian Ruble'},
    {iso: 'BZD', sign: '$', name: 'Belize Dollar'},
    {iso: 'BMD', sign: '$', name: 'Bermudian Dollar'},
    {iso: 'BTN', sign: 'Nu.', name: 'Bhutanese Ngultrum'},
    {iso: 'BOB', sign: 'Bs', name: 'Bolivian Boliviano'},
    {iso: 'BAM', sign: 'KM', name: 'Bosnia and Herzegovina Convertible Mark'},
    {iso: 'BWP', sign: 'P', name: 'Botswana Pula'},
    {iso: 'BRL', sign: 'R$', name: 'Brazilian Real'},
    {iso: 'BND', sign: '$', name: 'Brunei Dollar'},
    {iso: 'BGN', sign: '\u043b\u0432', name: 'Bulgarian Lev'},
    {iso: 'MMK', sign: 'K', name: 'Burmese Kyat'},
    {iso: 'BIF', sign: 'FBu', name: 'Burundian Franc'},
    {iso: 'KHR', sign: '\u17db', name: 'Cambodian Riel'},
    {iso: 'CVE', sign: '$', name: 'Cape Verde Escudo'},
    {iso: 'KYD', sign: '$', name: 'Cayman Islands Dollar'},
    {iso: 'XAF', sign: 'FCFA', name: 'Central African CFA Franc'},
    {iso: 'XPF', sign: 'F', name: 'CFP Franc'},
    {iso: 'CLP', sign: '$', name: 'Chilean Peso'},
    {iso: 'CNY', sign: '\u00a5', name: 'Chinese Yuan'},
    {iso: 'COP', sign: '$', name: 'Colombian Peso'},
    {iso: 'KMF', sign: 'CF', name: 'Comorian franc'},
    {iso: 'CDF', sign: 'FC', name: 'Congolese Franc'},
    {iso: 'CRC', sign: '\u20a1', name: 'Costa Rican Colon'},
    {iso: 'HRK', sign: 'kn', name: 'Croatian Kuna'},
    {iso: 'CUC', sign: '$', name: 'Cuban Convertible Peso'},
    {iso: 'CUP', sign: '\u20b1', name: 'Cuban Peso'},
    {iso: 'CZK', sign: 'K\u010d', name: 'Czech Koruna'},
    {iso: 'DKK', sign: 'kr.', name: 'Danish Krone'},
    {iso: 'DJF', sign: 'Fdj', name: 'Djiboutian Franc'},
    {iso: 'DOP', sign: '$', name: 'Dominican Peso'},
    {iso: 'XCD', sign: '$', name: 'East Caribbean Dollar'},
    {iso: 'EGP', sign: '\u00a3', name: 'Egyptian Pound'},
    {iso: 'ERN', sign: 'Nfk', name: 'Eritrean Nakfa'},
    {iso: 'ETB', sign: 'Br', name: 'Ethiopian Birr'},
    {iso: 'FKP', sign: '\u00a3', name: 'Falkland Islands Pound'},
    {iso: 'FJD', sign: '$', name: 'Fiji Dollar'},
    {iso: 'GMD', sign: 'D', name: 'Gambian Dalasi'},
    {iso: 'GEL', sign: '\u10da', name: 'Georgian Lari'},
    {iso: 'GHS', sign: '\u00a2', name: 'Ghanaian Cedi'},
    {iso: 'GIP', sign: '\u00a3', name: 'Gibraltar Pound'},
    {iso: 'GTQ', sign: 'Q', name: 'Guatemalan Quetzal'},
    {iso: 'GNF', sign: 'FG', name: 'Guinean Franc'},
    {iso: 'GYD', sign: '$', name: 'Guyanese Dollar'},
    {iso: 'HTG', sign: 'G', name: 'Haitian Gourde'},
    {iso: 'HNL', sign: 'L', name: 'Honduran Lempira'},
    {iso: 'HKD', sign: '$', name: 'Hong Kong Dollar'},
    {iso: 'HUF', sign: 'Ft', name: 'Hungarian Forint'},
    {iso: 'ISK', sign: 'kr', name: 'Icelandic Kr\u00f3na'},
    {iso: 'IDR', sign: 'Rp', name: 'Indonesian Rupiah'},
    {iso: 'IRR', sign: '\ufdfc', name: 'Iranian Rial'},
    {iso: 'IQD', sign: '\u0639.\u062f', name: 'Iraqi Dinar'},
    {iso: 'ILS', sign: '\u20aa', name: 'Israeli Shekel'},
    {iso: 'JMD', sign: '$', name: 'Jamaican Dollar'},
    {iso: 'JOD', sign: '\u062f.\u0627', name: 'Jordanian Dinar'},
    {iso: 'KZT', sign: '\u043b\u0432', name: 'Kazakhstani Tenge'},
    {iso: 'KES', sign: 'Sh', name: 'Kenyan Shilling'},
    {iso: 'KWD', sign: '\u062f.\u0643', name: 'Kuwaiti Dinar'},
    {iso: 'KGS', sign: '\u043b\u0432', name: 'Kyrgyzstani Som'},
    {iso: 'LAK', sign: '\u20ad', name: 'Lao Kip'},
    {iso: 'LBP', sign: '\u00a3', name: 'Lebanese Pound'},
    {iso: 'LSL', sign: 'L', name: 'Lesotho Loti'},
    {iso: 'LRD', sign: '$', name: 'Liberian Dollar'},
    {iso: 'LYD', sign: '\u0644.\u062f', name: 'Libyan Dinar'},
    {iso: 'MOP', sign: 'P', name: 'Macanese Pataca'},
    {iso: 'MKD', sign: '\u0434\u0435\u043d', name: 'Macedonian Denar'},
    {iso: 'MGA', sign: 'Ar', name: 'Malagasy Ariary'},
    {iso: 'MWK', sign: 'MK', name: 'Malawian Kwacha'},
    {iso: 'MYR', sign: 'RM', name: 'Malaysian Ringgit'},
    {iso: 'MVR', sign: 'Rf', name: 'Maldivian Rufiyaa'},
    {iso: 'MRU', sign: 'UM', name: 'Mauritanian Ouguiya'},
    {iso: 'MUR', sign: '\u20a8', name: 'Mauritian Rupee'},
    {iso: 'MXN', sign: '$', name: 'Mexican Peso'},
    {iso: 'MDL', sign: 'L', name: 'Moldovan Leu'},
    {iso: 'MNT', sign: '\u20ae', name: 'Mongolian T\u00f6gr\u00f6g'},
    {iso: 'MAD', sign: '\u062f.\u0645.', name: 'Moroccan Dirham'},
    {iso: 'MZN', sign: 'MT', name: 'Mozambican Metical'},
    {iso: 'NAD', sign: '$', name: 'Namibian Dollar'},
    {iso: 'NPR', sign: '\u20a8', name: 'Nepalese Rupee'},
    {iso: 'ANG', sign: '\u0192', name: 'Netherlands Antillean Guilder'},
    {iso: 'TWD', sign: '$', name: 'New Taiwan Dollar'},
    {iso: 'NZD', sign: '$', name: 'New Zealand Dollar'},
    {iso: 'NIO', sign: '$', name: 'Nicaraguan C\u00f3rdoba'},
    {iso: 'NGN', sign: '\u20a6', name: 'Nigerian Naira'},
    {iso: 'KPW', sign: '\u20a9', name: 'North Korean Won'},
    {iso: 'NOK', sign: 'kr', name: 'Norwegian Krone'},
    {iso: 'OMR', sign: '\ufdfc', name: 'Omani Rial'},
    {iso: 'PKR', sign: '\u20a8', name: 'Pakistani Rupee'},
    {iso: 'PAB', sign: 'B.', name: 'Panamanian Balboa'},
    {iso: 'PGK', sign: 'K', name: 'Papua New Guinean Kina'},
    {iso: 'PYG', sign: '\u20b2', name: 'Paraguayan Guaran\u00ed'},
    {iso: 'PEN', sign: 'S.', name: 'Peruvian Nuevo Sol'},
    {iso: 'PHP', sign: '\u20b1', name: 'Philippine Peso'},
    {iso: 'PLN', sign: 'z\u0142', name: 'Polish Z\u0142oty'},
    {iso: 'QAR', sign: '\ufdfc', name: 'Qatari Riyal'},
    {iso: 'RON', sign: 'L', name: 'Romanian Leu'},
    {iso: 'ALL', sign: 'L', name: 'Albanian Lek'},
    {iso: 'RWF', sign: 'FRw', name: 'Rwandan Franc'},
    {iso: 'SHP', sign: '\u00a3', name: 'Saint Helena Pound'},
    {iso: 'WST', sign: '$', name: 'Samoan T\u0101l\u0101'},
    {iso: 'STN', sign: 'Db', name: 'S\u00e3o Tom\u00e9 and Pr\u00edncipe Dobra'},
    {iso: 'SAR', sign: '\ufdfc', name: 'Saudi Riyal'},
    {iso: 'RSD', sign: 'RSD', name: 'Serbian Dinar'},
    {iso: 'SCR', sign: 'SR', name: 'Seychelles Rupee'},
    {iso: 'SLL', sign: 'Le', name: 'Sierra Leonean Leone'},
    {iso: 'SGD', sign: '$', name: 'Singapore Dollar'},
    {iso: 'SBD', sign: '$', name: 'Solomon Islands Dollar'},
    {iso: 'SOS', sign: 'S', name: 'Somali Shilling'},
    {iso: 'ZAR', sign: 'R', name: 'South African Rand'},
    {iso: 'KRW', sign: '\u20a9', name: 'South Korean Won'},
    {iso: 'SSP', sign: '\u00a3', name: 'South Sudanese Pound'},
    {iso: 'LKR', sign: '\u20a8', name: 'Sri Lankan Rupee'},
    {iso: 'SDG', sign: '\u00a3', name: 'Sudanese Pound'},
    {iso: 'SRD', sign: '$', name: 'Surinamese Dollar'},
    {iso: 'SZL', sign: 'L', name: 'Swazi Lilangeni'},
    {iso: 'SEK', sign: 'kr', name: 'Swedish Krona'},
    {iso: 'SYP', sign: '\u00a3', name: 'Syrian Pound'},
    {iso: 'TJS', sign: 'SM', name: 'Tajikistani Somoni'},
    {iso: 'TZS', sign: 'Sh', name: 'Tanzanian Shilling'},
    {iso: 'TOP', sign: '$', name: 'Tongan Pa\u02bbanga'},
    {iso: 'TTD', sign: '$', name: 'Trinidad and Tobago Dollar'},
    {iso: 'TND', sign: '\u062f.\u062a', name: 'Tunisian Dinar'},
    {iso: 'TRY', sign: '\u20a4', name: 'Turkish Lira'},
    {iso: 'TMT', sign: 'm', name: 'Turkmenistani Manat'},
    {iso: 'UGX', sign: 'Ush', name: 'Ugandan Shilling'},
    {iso: 'UAH', sign: '\u20b4', name: 'Ukrainian Hryvnia'},
    {iso: 'UYU', sign: '$', name: 'Uruguayan Peso'},
    {iso: 'UYW', sign: 'UP', name: 'Unidad Previsional'},
    {iso: 'UZS', sign: '\u043b\u0432', name: 'Uzbekistan Som'},
    {iso: 'VUV', sign: 'VT', name: 'Vanuatu Vatu'},
    {iso: 'VES', sign: 'Bs.S.', name: 'Venezuelan Bol\u00edvar Soberano'},
    {iso: 'VND', sign: '\u20ab', name: 'Vietnamese Dong'},
    {iso: 'XOF', sign: 'CFA', name: 'West African CFA Franc'},
    {iso: 'YER', sign: '\ufdfc', name: 'Yemeni Rial'},
    {iso: 'ZMW', sign: 'ZK', name: 'Zambian Kwacha'},
];

export default CURRENCIES;

export const CURRENCIES_LIST = CURRENCIES
    .map(currency => ({label: `${currency.iso} - ${currency.name}`, value: currency.iso}));
